import { render } from "./TestcaseLabelCreate.vue?vue&type=template&id=b7fa823c"
import script from "./TestcaseLabelCreate.vue?vue&type=script&lang=js"
export * from "./TestcaseLabelCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__